// check password
export function checkPassword(arg) {
  let regex = new RegExp(
    "^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-_]).{6,}$",
    "g"
  );
  return regex.test(arg);
}
